import { useEffect, useState } from "react";
import urls from "../../../../Utils/urls";
import axiosInstance from "../../../../axios";

const useTickets = (refreshTable) => {
  const [tickets, setTickets] = useState(null);

  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    async function getTicketsCount() {
      try {
        const keys = ["OPEN", "CLOSED"];
        const res = await Promise.all(
          keys.map((item) =>
            axiosInstance.get(urls.support.getStatusTickets(userId, item), {
              headers: {
                Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
              },
            })
          )
        );
        const counts = res.map((el) => el.data.count);
        setTickets(counts);
      } catch (error) {
        console.error(error);
      }
    }
    getTicketsCount();
  }, [refreshTable]);

  return tickets;
};

export default useTickets;
